'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceCompat(e) {
    if (e && typeof e === 'object' && 'default' in e) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceCompat(React);

const Svg24 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.103 3c-.497 0-.953.273-1.187.712l-.47.88H3.1a1.1 1.1 0 0 0 0 2.2h17.847a1.1 1.1 0 0 0 0-2.2h-5.659l-.278-.727C14.811 3.344 14.311 3 13.753 3z", fill: props.fillColor, fillOpacity: 0.92 }),
    React__namespace.createElement("path", { d: "m4.948 9.372 1.136 9.733a2.69 2.69 0 0 0 2.673 2.38h6.522a2.69 2.69 0 0 0 2.663-2.307l1.418-9.806", stroke: props.strokeColor, strokeOpacity: 0.92, strokeWidth: 2.198, strokeLinecap: "round" }),
    React__namespace.createElement("path", { d: "M10.123 11.391v5.383m4.038-5.383v5.383", stroke: props.strokeColor, strokeOpacity: 0.92, strokeWidth: 2.2, strokeLinecap: "round" })));

exports.default = Svg24;
//# sourceMappingURL=24.js.map
